var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
import ConnectLivekit from '../ConnectLivekit';
const useLivekitConnect = () => {
    _react_refresh_temp_1();
    const [error, setError] = useState();
    const [roomConnectionStatus, setRoomConnectionStatus] = useState('loading');
    const startLivekitConnection = (info) => {
        return new ConnectLivekit(info, setError, setRoomConnectionStatus);
    };
    return {
        error,
        setError,
        roomConnectionStatus,
        setRoomConnectionStatus,
        startLivekitConnection,
    };
};
_react_refresh_temp_1(useLivekitConnect, "ZxrCuUkwUWlC6TNUzWbzuRHb6uI=");
export default useLivekitConnect;
